export const meetingData = {
    year: "53. ročník turistického srazu",
    title: "Za posledním puchýřem",
    date: "14. - 17.11.2025",
    city: "Hlučín",
    region: "Moravskoslezský kraj",
    district: "okres Opava",
    actualInfo: "Aktuální informace",
    initialMeetingTitle: "O turistickém srazu",
    initialMeetingDetail: [
      "Turistický sraz „Za posledním puchýřem“ je turisticko-společenská akce Klubu českých turistů, která oficiálně zakončuje hlavní turistickou sezónu. Koná se vždy v listopadu, každý rok v jiné části republiky.",
      "53. ročník se uskuteční v Moravskoslezském kraji - v Hlučíně a jeho okolí. V roce 2025 si připomínáme 80 let od ukončení 2. světové války. Právě zde, mezi Opavou a Ostravou, probíhala významná vojenská operace s cílem osvobodit strategicky důležitý průmyslový region Ostravy a zároveň přispět k porážce německých sil ve střední Evropě.",
      "Vydejte se s námi do míst, kudy v minulosti procházela Jantarová cesta, seznamte se s historií, projděte se krásnou přírodou, potkejte se s přáteli a pobavte se na společenských akcích, které jsme pro vás v rámci doprovodného programu připravili."
    ],
    mainMeetingPartner: "Hlavní partner akce:",
    meetingPartners: "Partneři akce:",
    patronate: "Turistický sraz se koná pod záštitou Města Hlučín.",
};